import { render, staticRenderFns } from "./CCOffIcon.vue?vue&type=template&id=0992f669&"
import script from "./CCOffIcon.vue?vue&type=script&lang=js&"
export * from "./CCOffIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports